import { __ } from '@wordpress/i18n';
import Control from './Control';
const { useState } = wp.element;
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const { showSideText, sideText } = attributes
  const [sideTextPreview, setSideTextPreview] = useState(sideText);

  return (
    <>
      <Control
        attributes={attributes}
        setAttributes={setAttributes}
        setSideTextPreview={setSideTextPreview}
      />

      <label className='Input-label'>
        <input type="text" className="Input" />
        {showSideText && (
          <span className='Input-sideText'>{sideTextPreview}</span>
        )}
      </label>
    </>
  );
}
